import { atom, getDefaultStore, useAtomValue, useSetAtom } from 'jotai'
import { selectAtom } from 'jotai/utils'

// Define the atom with an explicit generic type parameter to allow any string
const inputAtom = atom<string>('')

// a derived atom that only notifies when its boolean flips
export const hasChatInputAtom = selectAtom(inputAtom, (input) => {
  return input.length > 0
})

export const useHasChatInput = () => {
  return useAtomValue(hasChatInputAtom)
}

export const useCurrentChatInput = () => {
  return useAtomValue(inputAtom)
}

export const getCurrentChatInput = () => {
  const defaultStore = getDefaultStore()
  return defaultStore.get(inputAtom)
}

export const useSetChatInput = () => {
  return useSetAtom(inputAtom)
}
